import { booleanAttribute, ChangeDetectionStrategy, Component, computed, forwardRef, input, signal } from "@angular/core";
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { RadioButton } from "primeng/radiobutton";

export interface Kno2RadioOption {
    label: string;
    value: unknown;
}

let nextId = 0;

@Component({
    selector: "kno2-form-radio-input",
    imports: [FormsModule, RadioButton],
    templateUrl: "./form-radio-input.component.html",
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FormRadioInputComponent), multi: true }],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormRadioInputComponent implements ControlValueAccessor {
    public readonly options = input<Kno2RadioOption[]>([]);
    public readonly name = input<string>(`kno2-form-radio-${nextId++}`);
    public readonly displayInline = input<boolean, unknown>(false, { transform: booleanAttribute });
    public readonly disabledInput = input<boolean, unknown>(false, { alias: "disabled", transform: booleanAttribute });

    protected readonly value = signal<unknown>(null);
    protected readonly cvaDisabled = signal(false);
    protected readonly disabled = computed(() => this.disabledInput() || this.cvaDisabled());
    protected readonly standaloneNgModel = { standalone: true };

    private onChange: (value: unknown) => void = () => {};
    private onTouched: () => void = () => {};

    public writeValue(value: unknown): void {
        this.value.set(value);
    }

    public registerOnChange(fn: (value: unknown) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.cvaDisabled.set(isDisabled);
    }

    protected handleChange(value: unknown): void {
        this.value.set(value);
        this.onChange(value);
        this.onTouched();
    }

    protected optionInputId(value: unknown): string {
        return `${this.name()}-${value}`;
    }
}
